import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../../context/CookieConsentContext';

const CookieBanner: React.FC = () => {
  const { isBannerVisible, acceptAll, rejectNonEssential, openPreferences } =
    useCookieConsent();
  const bannerRef = useRef<HTMLDivElement>(null);
  const firstButtonRef = useRef<HTMLButtonElement>(null);

  // Move focus into banner when it appears for keyboard accessibility
  useEffect(() => {
    if (isBannerVisible && firstButtonRef.current) {
      firstButtonRef.current.focus();
    }
  }, [isBannerVisible]);

  if (!isBannerVisible) return null;

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-modal="false"
      aria-label="Cookie consent"
      aria-live="polite"
      ref={bannerRef}
      data-testid="cookie-banner"
    >
      <div className="cookie-banner__inner">
        <div className="cookie-banner__content">
          <div className="cookie-banner__icon" aria-hidden="true">🍪</div>
          <div className="cookie-banner__text">
            <p className="cookie-banner__title">We use cookies</p>
            <p className="cookie-banner__description">
              LookBel uses cookies to keep the site working, improve your
              experience, and understand how people use our platform. Essential
              cookies are always on.{' '}
              <Link to="/privacy" className="cookie-banner__link">
                Learn more
              </Link>
            </p>
          </div>
        </div>

        <div className="cookie-banner__actions">
          <button
            ref={firstButtonRef}
            className="cookie-banner__btn cookie-banner__btn--accept"
            onClick={acceptAll}
            aria-label="Accept all cookies"
            data-testid="cookie-accept-all"
          >
            Accept All
          </button>
          <button
            className="cookie-banner__btn cookie-banner__btn--reject"
            onClick={rejectNonEssential}
            aria-label="Reject non-essential cookies"
            data-testid="cookie-reject"
          >
            Reject Non-Essential
          </button>
          <button
            className="cookie-banner__btn cookie-banner__btn--customize"
            onClick={openPreferences}
            aria-label="Customize cookie preferences"
            data-testid="cookie-customize"
          >
            Customize
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
